/**
 * ZİYARETÇİ HANGİ TELEFONDA?
 *
 * Bileşenden ayrı duruyor ki sınanabilsin: bu mantık sessizce bozulabilecek
 * türden — yanlış tarafa düşerse ya kimse şeridi görmez ya da masaüstü
 * kullanıcısına anlamsız bir mağaza linki gösterilir. İkisi de fark
 * edilmeden aylarca durabilir.
 *
 * @param {{userAgent?: string, maxTouchPoints?: number}} gezgin  navigator
 * @param {object} pencere  window (uygulama içi WebView tespiti için)
 * @returns {"ios"|"android"|null}
 */
export function mobilPlatformBul(gezgin, pencere) {
  if (!gezgin) return null;
  const ua = String(gezgin.userAgent || "");
  if (!ua) return null;

  /* UYGULAMANIN KENDİ İÇİNDE ÖNERME. Zaten uygulamadaki birine
     "uygulamayı indir" demek saçmadır; React Native köprüsü ya da özel
     ajan imzası bunu ele verir. */
  if (pencere && pencere.ReactNativeWebView) return null;
  if (/ChatPilotsApp|Expo/i.test(ua)) return null;

  if (/iPad|iPhone|iPod/i.test(ua)) return "ios";

  /* iPadOS 13+ kendini MASAÜSTÜ Safari gibi tanıtıyor ("Macintosh"),
     dokunma noktası sayısı onu ele veriyor. Bu satır olmadan iPad
     kullanıcıları şeridi hiç görmez. */
  if (/Macintosh/i.test(ua) && Number(gezgin.maxTouchPoints) > 1) return "ios";

  if (/Android/i.test(ua)) return "android";
  return null;
}

export default mobilPlatformBul;
